import * as angular from 'angular';

const fdEditOverlayHtml = require('../../views/fd_edit_overlay.html');

'use strict';

angular.module('formApp').directive('fdEditOverlay', function () {
  return {
    scope: {
      models: '='
    },
    templateUrl: fdEditOverlayHtml,
    replace: true,
    controller: 'fdEditOverlayCtrl'
  };
});
